import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _Footer;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { CondensedButton } from '@instructure/ui-buttons';
import { IconPlusLine } from '@instructure/ui-icons';
import { jsx } from '@instructure/emotion';
import { ScreenReaderContent, PresentationContent } from '@instructure/ui-a11y-content';
import { omitProps } from '@instructure/ui-react-utils';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';
var Footer = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_Footer = /*#__PURE__*/function (_Component) {
  function Footer() {
    var _this2;
    _classCallCheck(this, Footer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, Footer, [].concat(args));
    _defineProperty(_this2, "buttonRef", null);
    _defineProperty(_this2, "onClick", function () {
      var _this2$props = _this2.props,
        buttonText = _this2$props.buttonText,
        notifyScreenreader = _this2$props.notifyScreenreader;
      _this2.props.onCreateChoice();
      notifyScreenreader(t('{type} added above.', {
        type: buttonText || t('Answer')
      }));
    });
    _defineProperty(_this2, "handleSaveRef", function (node) {
      _this2.buttonRef = node;
    });
    return _this2;
  }
  _inherits(Footer, _Component);
  return _createClass(Footer, [{
    key: "focus",
    value: function focus() {
      this.buttonRef.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        buttonText = _this$props.buttonText,
        screenReaderText = _this$props.screenReaderText,
        automationData = _this$props.automationData;
      return jsx("div", {
        css: this.props.styles.footerSection
      }, jsx("div", {
        css: this.props.styles.answerButtonWrapper
      }, jsx(CondensedButton, Object.assign({
        ref: this.handleSaveRef,
        onClick: this.onClick,
        renderIcon: IconPlusLine,
        margin: "small",
        "data-automation": automationData || 'sdk-add-answer-button'
      }, omitProps(this.props, this.constructor.propTypes)), jsx("span", {
        css: this.props.styles.addAnswerButtonText
      }, jsx(ScreenReaderContent, null, screenReaderText || t('Add Answer')), jsx(PresentationContent, null, buttonText || t('Answer'))))));
    }
  }]);
}(Component), _defineProperty(_Footer, "displayName", 'Footer'), _defineProperty(_Footer, "componentId", "Quizzes".concat(_Footer.displayName)), _defineProperty(_Footer, "propTypes", {
  buttonText: PropTypes.string,
  screenReaderText: PropTypes.string,
  onCreateChoice: PropTypes.func,
  notifyScreenreader: PropTypes.func,
  styles: PropTypes.object,
  automationData: PropTypes.string
}), _defineProperty(_Footer, "defaultProps", {
  buttonText: null,
  onCreateChoice: function onCreateChoice() {},
  screenReaderText: null,
  notifyScreenreader: function notifyScreenreader() {}
}), _Footer)) || _class);
export { Footer as default };